import React from 'react';
import PropTypes from 'prop-types';

export const CircleCheckboxIcon = ({ fontSize, color }) => {
  return (
    <svg width={fontSize} height={fontSize} viewBox="0 0 40 40" fill="none">
      <circle cx="20" cy="20" r="19" stroke={color} strokeWidth="2" />
      <path d="M12 19.6169L17.8909 25.0169L28.4455 15.1987" stroke={color} strokeWidth="3" />
    </svg>
  );
};

CircleCheckboxIcon.propTypes = {
  fontSize: PropTypes.string, // 40
  color: PropTypes.string, // titan-blue-3
};
CircleCheckboxIcon.defaultProps = {
  fontSize: '40',
  color: 'var(--titan-blue-3)',
};
